import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rootRoute } from './_root';

// Public customer-preview discussion link (Main DB standing token).
// PRD: apps/itineraries/prd/customer-preview-discussion.md
// URL: /customer-preview/$itineraryId?token=...

type CustomerPreviewSearch = {
  token?: string;
};

const validateCustomerPreviewSearch = (
  input: Record<string, unknown>
): CustomerPreviewSearch => ({
  token: typeof input.token === 'string' ? input.token : undefined,
});

export const customerPreviewDiscussionRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'customer-preview/$itineraryId',
  validateSearch: validateCustomerPreviewSearch,
  // Token in query string — do not leak via Referer.
  head: () => ({
    meta: [{ name: 'referrer', content: 'no-referrer' }],
  }),
  component: lazyRouteComponent(() =>
    import('@itineraries/pages/customer-preview').then((m) => ({
      default: m.CustomerPreviewPage,
    }))
  ),
});
